export default {
  request_type: '',
  capsuleid: '',
  clientid: '',
  fingerprint: '',
  referrer: '',
  trackermessage: '',
  trackersource: '',
  trackeragent: '',
  trackerip: ''
}



// WEBPACK FOOTER //
// ./src/model/Tracking.js